/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Input, message, Checkbox } from 'antd';
import Button from 'components/generalUI/Button';
import useGetPromotionCodeQuery from 'apollo/resolvers/promotionCodes/get';
import LoadingModal from 'components/generalUI/LoadingModal';
import { PromotionCode } from 'apollo/types';
import { getOrCreatePurchase, setPurchase } from 'storage/purchaseStore';
import styles from './PromotionCodeInput.module.scss';

interface PromotionCodeProps {
  setPromotionCode: React.Dispatch<React.SetStateAction<PromotionCode | null>>;
  date: string;
}

const PromotionCodeInput: FC<PromotionCodeProps> = ({
  setPromotionCode,
  date,
}: PromotionCodeProps) => {
  const { t } = useTranslation();

  const [code, setCode] = useState('');
  const [getPromotionCode, { data, loading }] = useGetPromotionCodeQuery();
  const [isFormVisible, setIsFormVisible] = useState(false);

  const isDataFromGetPromotionCodeQueryValid = () => {
    if (data) {
      const dateAsDate = new Date(date);
      const isForWeekends = dateAsDate.getDay() === 6 || dateAsDate.getDay() === 0;
      if (data.getPromotionCode) {
        if (!data.getPromotionCode.forWeekends && isForWeekends) {
          message.error(t('checkout.summary.promotionCodeErrorWeekend'), 1);
        } else {
          setPromotionCode(data.getPromotionCode);
          setPurchase({ ...getOrCreatePurchase(date), code });
          message.success(t('checkout.summary.correctCode'));
        }
      } else {
        message.error(t('checkout.summary.incorrectCode'));
      }
    }
  };

  const handleVisibilityChange = () => {
    setIsFormVisible(!isFormVisible);
  };

  useEffect(() => {
    isDataFromGetPromotionCodeQueryValid();
  }, [data]);

  return (
    <>
      <Row justify="center">
        <Col xs={20} lg={15} className={styles.Title}>
          <Checkbox onChange={handleVisibilityChange}>
            {t('checkout.summary.havePromotionCode')}
          </Checkbox>
        </Col>
      </Row>
      <Row justify="center" hidden={!isFormVisible}>
        <LoadingModal visible={loading} />
        <Col className={styles.PromotionCode} xs={20} lg={15}>
          <Input
            className={styles.Input}
            placeholder={t('checkout.summary.discountCode')}
            onChange={(event) => setCode(event.target.value)}
          />
        </Col>
        <Col className={styles.PromotionCode} xs={20} lg={15}>
          <Button
            type="primary"
            className={styles.SubmitButton}
            kind="secondary"
            disabled={!code}
            onClick={() => {
              getPromotionCode({ variables: { code } });
            }}
          >
            {t('checkout.summary.submitCode')}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default PromotionCodeInput;
